import BaseService from "./BaseService";

class ServiceSeller extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest";
	}

	getSeller(code) {
		let url = this.serviceUrl + `/seller?sellerCode=${code}`;
		return this.opencellAPI.callApi(url);
	}
}

const serviceSeller = new ServiceSeller();
export default serviceSeller;



// WEBPACK FOOTER //
// ./src/opencell/services/ServiceSeller.js